.page {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 40px;
  background: var(--bg);
}

.notice {
  margin: 0 32px 16px;
  padding: 10px 14px;
  font-size: 13.5px;
  border-radius: var(--r-sm);
}

.noticeOk {
  color: var(--ok);
  background: var(--ok-bg);
}
.noticeError {
  color: var(--err);
  background: var(--err-bg);
}

/* ── Состояние сети ──
   Цвета — из переменных --hero-*, --tile-*, --led-* (styles/tokens.css):
   в светлой теме полоса светлая, в тёмной — тёмно-синяя. */
.health {
  display: grid;
  grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
  gap: 32px;
  margin: 0 32px;
  padding: 28px 32px;
  color: var(--hero-text);
  background: var(--hero-bg);
  border: 1px solid var(--hero-border);
  border-radius: var(--r-lg);
}

.healthTitle {
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 600;
  color: var(--hero-strong);
}

.bigValue {
  font-size: 52px;
  font-weight: 650;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--hero-strong);
  font-variant-numeric: tabular-nums;
}

.bigLabel {
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 1.45;
}

.checked {
  margin-top: 24px;
}

.checkedRow {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}

.checkedValue {
  color: var(--hero-strong);
  font-variant-numeric: tabular-nums;
}

.checkedBar {
  height: 6px;
  margin-top: 8px;
  overflow: hidden;
  background: var(--hero-track);
  border-radius: var(--r-bar);
}

.checkedBar span {
  display: block;
  height: 100%;
  background: var(--led-checked);
  border-radius: var(--r-bar);
}

.legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 24px 0 0;
  padding: 0;
  font-size: 12.5px;
  list-style: none;
}

.legend li {
  display: flex;
  align-items: center;
  gap: 8px;
}
.legend i {
  width: 14px;
  height: 4px;
  border-radius: 1px;
}

.dotClean {
  background: var(--led-clean);
}
.dotChecked {
  background: var(--led-checked);
}
.dotOpen {
  background: var(--led-open);
}

/* Плитки объектов по дивизионам */
.map {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  max-height: 420px;
  padding-right: 4px;
  overflow-y: auto;
}

.division {
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.divisionName {
  padding-top: 9px;
  font-size: 13px;
  font-weight: 600;
  color: var(--hero-strong);
}

.tiles {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tile {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  width: 64px;
  height: 40px;
  padding: 6px 7px 6px;
  color: var(--hero-strong);
  text-align: left;
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  border-radius: 4px;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
}

.tile:hover {
  background: var(--tile-hover);
  border-color: var(--slate-lt);
}

.tileLabel {
  font: 600 12.5px var(--mono);
  line-height: 1;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.tilePrefix {
  margin-right: 3px;
  font-size: 9.5px;
  font-weight: 500;
  color: var(--tile-muted);
}

/* Полоска-индикатор: доли коммутаторов объекта в трёх состояниях */
.strip {
  display: flex;
  gap: 1px;
  height: 4px;
  overflow: hidden;
  border-radius: 1px;
}

.segClean {
  background: var(--led-clean);
}
.segChecked {
  background: var(--led-checked);
}
.segOpen {
  background: var(--led-open);
}

/* ── Две колонки ── */

.columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 24px;
  align-items: start;
  margin: 24px 32px 0;
}

.blockHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  margin-bottom: 12px;
}

.blockTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.search {
  width: 240px;
  margin-left: auto;
}

.filterChip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  padding: 0 10px;
  font-size: 13px;
  color: var(--blue);
  background: var(--blue-lt);
  border: 1px solid color-mix(in srgb, var(--blue) 30%, transparent);
  border-radius: var(--r-pill);
  cursor: pointer;
}

.filterChip span {
  font-size: 16px;
  line-height: 1;
}

html:global(.dark) .filterChip {
  color: var(--navy-accent);
}

.tableWrap {
  max-height: calc(100vh - 160px);
  overflow: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.table {
  width: 100%;
  font-size: 13.5px;
  border-collapse: collapse;
}

.table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-align: left;
  white-space: nowrap;
  background: var(--card-bg);
  box-shadow: inset 0 -1px 0 var(--border);
}

.table td {
  padding: 10px 14px;
  color: var(--text);
  vertical-align: top;
  border-bottom: 1px solid var(--border);
}

.table tbody tr {
  cursor: pointer;
}
.table tbody tr:last-child td {
  border-bottom: none;
}
.table tbody tr:hover td,
.table tbody tr:focus-visible td {
  background: var(--table-hover);
}
.table tbody tr:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: -2px;
}

.rowDone td {
  color: var(--text2);
}

.nowrap {
  white-space: nowrap;
}
.mono {
  font-family: var(--mono);
  font-size: 12.5px;
  white-space: nowrap;
}
.dash {
  color: var(--slate-lt);
}

.issues {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 260px;
}

.issue {
  padding: 1px 7px;
  font-size: 12px;
  line-height: 18px;
  color: var(--err);
  white-space: nowrap;
  background: var(--err-bg);
  border-radius: 4px;
}

.rowDone .issue {
  color: var(--text2);
  background: var(--table-even);
}

.doneMark {
  padding: 1px 7px;
  font-size: 12px;
  line-height: 18px;
  color: var(--ok);
  white-space: nowrap;
  background: var(--ok-bg);
  border-radius: 4px;
}

.empty {
  padding: 40px 20px;
  font-size: 14px;
  color: var(--text2);
  text-align: center;
}

/* Таблица не должна распирать колонку */
.records {
  min-width: 0;
}

/* ── Правая колонка ── */

.aside {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card {
  padding: 18px 18px 14px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.cardNote {
  margin: 4px 0 12px;
  font-size: 12.5px;
  color: var(--text2);
}

.allClear {
  margin: 8px 0 4px;
  font-size: 13.5px;
  color: var(--ok);
}

.issueList,
.startList {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0 -8px;
  padding: 0;
  list-style: none;
}

.issueRow,
.startRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 12px;
  width: 100%;
  padding: 8px;
  color: var(--text);
  text-align: left;
  background: none;
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.issueRow:hover,
.startRow:hover {
  background: var(--table-hover);
}

.issueRowActive,
.issueRowActive:hover {
  background: var(--blue-lt);
  box-shadow: inset 3px 0 0 var(--blue);
}

.issueName {
  font-size: 13.5px;
}

.issueCount {
  font-size: 13.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.issueBar,
.startBar {
  grid-column: 1 / -1;
  height: 4px;
  overflow: hidden;
  background: var(--border);
  border-radius: var(--r-bar);
}

.issueBar span,
.startBar span {
  display: block;
  height: 100%;
  border-radius: var(--r-bar);
}

.barWarn {
  background: var(--warn);
}
.barErr {
  background: var(--err);
}
.startBar span {
  background: var(--ok);
}

.startName {
  font-size: 13.5px;
  font-weight: 500;
}

.startLeft {
  font-size: 12.5px;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

.models {
  width: 100%;
  margin-top: 10px;
  font-size: 13px;
  border-collapse: collapse;
}

.models th {
  padding: 0 0 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text2);
  text-align: left;
}

.models th:not(:first-child),
.num {
  text-align: right;
  padding-left: 10px;
}

.models td {
  padding: 7px 0;
  color: var(--text);
  vertical-align: top;
  border-top: 1px solid var(--border);
}

.num {
  font-variant-numeric: tabular-nums;
}

.shareBar {
  display: block;
  height: 3px;
  margin-top: 5px;
  overflow: hidden;
  background: var(--border);
  border-radius: var(--r-bar);
}

.shareBar span {
  display: block;
  height: 100%;
  background: var(--blue);
}

.more {
  margin-top: 8px;
  padding: 4px 0;
  font-size: 13px;
  color: var(--blue);
  background: none;
  border: none;
  cursor: pointer;
}

html:global(.dark) .more {
  color: var(--navy-accent);
}

/* ── Узкие экраны ── */

@media (max-width: 1279px) {
  .health {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .summary {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0 32px;
    align-items: end;
  }
  .healthTitle {
    grid-column: 1 / -1;
  }
  .bigLabel {
    grid-column: 1;
  }
  .checked {
    grid-column: 2;
    grid-row: 2 / 4;
    margin-top: 0;
    align-self: center;
  }
  .legend {
    grid-column: 1 / -1;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px 18px;
  }
}

@media (max-width: 1179px) {
  .columns {
    grid-template-columns: 1fr;
  }
  .aside {
    order: -1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  }
}

@media (max-width: 699px) {
  .notice {
    margin: 0 16px 12px;
  }
  .health {
    margin: 0 16px;
    padding: 20px 16px;
  }
  .summary {
    display: block;
  }
  .checked {
    margin-top: 18px;
  }
  .bigValue {
    font-size: 40px;
  }
  .division {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .divisionName {
    padding-top: 0;
  }
  .columns {
    margin: 16px 16px 0;
  }
  .aside {
    display: flex;
  }
  .search {
    width: 100%;
    margin-left: 0;
  }
  .tableWrap {
    max-height: none;
  }

  /* Проблемные записи — списком: коммутатор, где стоит, замечания */
  .table,
  .table tbody,
  .table td {
    display: block;
  }
  .table thead {
    display: none;
  }
  .table tbody tr {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    column-gap: 6px;
    padding: 12px 14px;
    border-bottom: 1px solid var(--border);
  }
  .table tbody tr:last-child {
    border-bottom: none;
  }
  .table td {
    padding: 0;
    border: none;
  }
  .table tbody tr:hover,
  .table tbody tr:focus-visible {
    background: var(--table-hover);
  }
  .table tbody tr:hover td,
  .table tbody tr:focus-visible td {
    background: none;
  }
  /* Первая строка — объект и коммутатор, вторая — адрес, шкаф,
     расположение, третья — замечания. Перенос строки — пустым
     элементом ::before на всю ширину */
  .table tbody tr::before {
    content: '';
    flex-basis: 100%;
    height: 0;
    order: 2;
  }
  .cellObject {
    order: 1;
    font-weight: 600;
  }
  .cellSwitch {
    order: 1;
  }
  .cellMeta {
    order: 3;
    margin-top: 2px;
    font-size: 12.5px;
    color: var(--text2);
  }
  .cellMeta:has(> .dash) {
    display: none;
  }
  .cellMeta[data-label]::before {
    content: attr(data-label) ' ';
  }
  .cellMeta:not(:has(> .dash)) ~ .cellMeta::before {
    content: '· ';
  }
  .cellMeta:not(:has(> .dash)) ~ .cellMeta[data-label]::before {
    content: '· ' attr(data-label) ' ';
  }
  .cellIssues {
    order: 4;
    flex-basis: 100%;
    margin-top: 8px;
  }
  .issues {
    min-width: 0;
  }
}
